import { useLoader } from '../../store/loader';

export const useCartApiClient = () => {
    const { cartClient } = useLoader();

    return cartClient;
};
